import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-btn-nuevo-tipo-movimiento',
  templateUrl: './btn-nuevo-tipo-movimiento.component.html',
  styleUrls: ['./btn-nuevo-tipo-movimiento.component.css']
})
export class BtnNuevoTipoMovimientoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
